import styled, { css } from 'styled-components';
import Thumbnail from 'components/Thumbnail';
import { getThemeColor } from 'utils/styled';
import { StackedThumbnailtyleProps } from './types';

// Offset value used in the portrait image width calculation. This is a percentage
// adjustment added to the container width to ensure the portrait image maintains
// its correct aspect ratio while fitting neatly inside the container.
const PORTRAIT_WIDTH_OFFSET = '7%';

const stackedThumbnailCommonStyle = css<StackedThumbnailtyleProps>`
  position: absolute;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.15);

  &:nth-last-child(2),
  &:nth-last-child(3) {
    border: solid 0.4px ${getThemeColor('d4')};
    filter: brightness(50%);
  }

  &:last-child {
    border: solid 1px ${getThemeColor('d2')};
  }
`;

const stackedThumbnailItemStyle = css<StackedThumbnailtyleProps>`
  ${({ $ratio, $hasStack }) => {
    // Square.
    if ($ratio === 1) {
      return `
        &:nth-last-child(2) {
          transform: rotate(11deg) translate(16%, 8%) scale(0.6);
        }

        &:nth-last-child(3) {
          transform: rotate(-13deg) translate(-12%, 4%) scale(0.65);
        }

        &:last-child {
          transform: ${$hasStack ? 'translate(0, -6%)' : 'none'} scale(0.75);
        }
      `;
    }

    // Landscape.
    if ($ratio > 1) {
      return `
        &:nth-last-child(2) {
          transform: rotate(9deg) translate(6%, -27%) scale(0.75);
        }

        &:nth-last-child(3) {
          transform: rotate(-10deg) translate(-10%, 21%) scale(0.75);
        }

        &:last-child {
          transform: scale(0.85);
        }
      `;
    }

    // Portrait.
    if ($ratio < 1) {
      return `
        height: 100%;
        // Calculating dimensions for portrait images can be tricky; this formula 
        // ensures the dimensions of the image fits perfectly within the container 
        // while preserving its aspect ratio.
        width: calc(100% / 2 + ${PORTRAIT_WIDTH_OFFSET});
      
        &:nth-last-child(2) {
          transform: rotate(8deg) translate(36%, -1%) scale(0.75);
        }

        &:nth-last-child(3) {
          transform: rotate(-9deg) translate(-38%, -1%) scale(0.75);
        }
      `;
    }
  }}
`;

export const Root = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StackedThumbnail = styled(Thumbnail)<StackedThumbnailtyleProps>`
  ${stackedThumbnailCommonStyle};
  ${stackedThumbnailItemStyle};
`;
